import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import gsap from 'gsap';
import './LegalShared.css';

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const tl = gsap.timeline();
    tl.fromTo('.legal-header-main', { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8, ease: 'power2.out' })
      .fromTo('.legal-brief-box', { x: -30, opacity: 0 }, { x: 0, opacity: 1, duration: 0.8, ease: 'power2.out' }, "-=0.4")
      .fromTo('.legal-section-card', { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6, stagger: 0.15, ease: 'power2.out' }, "-=0.4");
  }, []);

  return (
    <div className="legal-page-shared">
      <div className="legal-container">
        <div className="legal-top-nav">
          <a href="/" className="back-link-gold">
            <ArrowLeft size={16} /> BACK TO HOME
          </a>
        </div>

        <header className="legal-header-main">
          <h1 className="legal-title-gold">Privacy Policy</h1>
          <p className="legal-subtitle-white">Guardian of your olfactory identity</p>
        </header>

        <div className="legal-brief-box">
          <span className="brief-label">EXECUTIVE SUMMARY</span>
          <p className="brief-text-gold">
            "Your privacy is the invisible essence of our relationship. We protect your personal data with the same rigor we use to guard our secret fragrance formulas."
          </p>
        </div>

        <div className="legal-content-grid">
          <section className="legal-section-card">
            <span className="section-tag">01. DATA ESSENCE</span>
            <h2 className="section-heading-gold">Information We Collect</h2>
            <p className="section-text-white">
              We collect only the most essential details to personalize your fragrance journey: your name, contact information, and olfactory preferences. This allows us to curate a collection that speaks directly to your soul.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">02. DISTILLATION</span>
            <h2 className="section-heading-gold">How We Use Your Data</h2>
            <p className="section-text-white">
              Your information is distilled into a personalized experience. We use it to process your luxury orders, provide concierge support, and keep you informed about our latest artisanal creations and private events.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">03. PROTECTION</span>
            <h2 className="section-heading-gold">Secure Vaults</h2>
            <p className="section-text-white">
              Our digital vaults use state-of-the-art encryption to ensure your data remains as private as a midnight bloom. We never sell your personal signature to third parties—it remains exclusively within the Maison Escentrum.
            </p>
          </section>

          <section className="legal-section-card">
            <span className="section-tag">04. YOUR RIGHTS</span>
            <h2 className="section-heading-gold">Olfactory Autonomy</h2>
            <p className="section-text-white">
              You have the absolute right to access, correct, or erase your data at any time. Simply contact our concierge, and we will fulfill your request with the utmost elegance and speed.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
